/**
 * The data sent between the windows directly on the Message Event.
 */
var CrossWindowCommunicationDataContract = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param type Data type.
     * @param detail Data detail.
     */
    function CrossWindowCommunicationDataContract(type, detail) {
        this.type = type;
        this.detail = detail;
    }
    return CrossWindowCommunicationDataContract;
}());
export { CrossWindowCommunicationDataContract };
//# sourceMappingURL=crossWindowDataContract.js.map